export const USER_FORGOT_PASSWORD_REQUEST = 'users/USER_FORGOT_PASSWORD_REQUEST';
export const USER_FORGOT_PASSWORD_REQUEST_FAIL = 'users/USER_FORGOT_PASSWORD_REQUEST_FAIL';
export const USER_FORGOT_PASSWORD_RESPONSE = 'users/USER_FORGOT_PASSWORD_RESPONSE';
export const HIDE_MODAL = 'users/HIDE_MODAL';
